import type { ApiResponse } from "../../../shared/types/api";
import { httpClient } from "../http-client";
import { NEW_API_ENDPOINTS } from "../../../shared/constants/api";
import type {
  MailIntegrationSetting,
  SaveMailIntegrationRequest,
} from "../../../domain/types/mail-integration";

export class MailIntegrationApiService {
  /** 메일 연동 설정 조회 (미설정 시 data=null) */
  async getSetting(
    companyId: number,
  ): Promise<ApiResponse<MailIntegrationSetting | null>> {
    const response = await httpClient.get<
      ApiResponse<MailIntegrationSetting | null>
    >(NEW_API_ENDPOINTS.mailIntegrationController.GET(companyId));

    if (response.data.errorCode) {
      throw new Error(
        response.data.errorMsg || "메일 연동 설정을 가져오지 못했습니다.",
      );
    }

    return response.data;
  }

  /** 메일 연동 설정 저장 (저장 시 IMAP 연결 검증 수행) */
  async saveSetting(
    companyId: number,
    request: SaveMailIntegrationRequest,
  ): Promise<ApiResponse<MailIntegrationSetting>> {
    const response = await httpClient.put<ApiResponse<MailIntegrationSetting>>(
      NEW_API_ENDPOINTS.mailIntegrationController.PUT(companyId),
      request,
    );

    if (response.data.errorCode) {
      throw new Error(
        response.data.errorMsg || "메일 연동 설정 저장에 실패했습니다.",
      );
    }

    return response.data;
  }
}

export const mailIntegrationApiService = new MailIntegrationApiService();
